export default {
  title: 'Overlappende tilbud i samme periode',
  buttons: {
    save_as_active: 'Sæt som nyt aktivt tilbud',
    save_as_inactive: 'Gem som inaktiv',
    cancel: 'Annuller',
  },
  description: {
    base: '{{offer}} overlapper med det aktive tilbud {{overlappingOffer}} på {{weekday}}{{between}}. Du kan kun køre ét tilbud ad gangen i samme periode.',
    between: ', mellem {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Sådan løser du det: Vælg en af mulighederne nedenfor.',
  },
};
